import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const STATIC = {
  "/": "Dashboard", "/about": "About", "/login": "Sign In", "/privacy": "Privacy",
  "/set-password": "Set Password", "/account/password": "Change Password",
  "/legislation": "Legislation", "/signals": "Live Signals", "/accuracy": "Forecast Accuracy",
  "/watchlist": "Watchlist", "/radar": "AI Radar", "/legislators": "Profiles", "/compare": "Compare",
  "/rankings": "Rankings", "/factions": "Backroom", "/committees": "Committees", "/parties": "Parties",
  "/admin/users": "User Access", "/admin/system": "System Health",
};
const PREFIX = [["/bill/", "Bill"], ["/legislator/", "Profile"], ["/committees/", "Committee"], ["/parties/", "Party"]];

export const pageTitle = (pathname) => {
  const name = STATIC[pathname] || PREFIX.find(([p]) => pathname.startsWith(p))?.[1] || "";
  return name ? `WHIP Intelligence - ${name}` : "WHIP Intelligence";
};

// Sets the browser tab to "WHIP Intelligence - Page". Detail pages refine it via setPageDetail once data loads.
export const usePageTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => { document.title = pageTitle(pathname); }, [pathname]);
};

export const setPageDetail = (detail) => {
  if (detail) document.title = `WHIP Intelligence - ${detail}`;
};
